var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8462 17.3636C10.8462 17.3636 6.27741 17.3636 4.76923 17.3636C2.68754 17.3636 1 15.6542 1 13.5455C1 12.0177 1.88579 10.6995 3.16551 10.0891C3.15777 9.96952 3.15385 9.84886 3.15385 9.72727C3.15385 6.71481 5.56462 4.27273 8.53846 4.27273C9.63617 4.27273 10.6572 4.60546 11.5085 5.17679C12.7542 2.69797 15.2967 1 18.2308 1C22.3941 1 25.7692 4.41892 25.7692 8.63636C25.7692 9.01643 25.7418 9.39001 25.6889 9.75519C27.5545 9.98418 29 11.5938 29 13.5455C29 15.6542 27.3125 17.3636 25.2308 17.3636H19.1538M15 12.4545V25M15 25L19.3077 20.6364M15 25L10.6923 20.6364",
    stroke: "#4FB1EB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.4afd9304.svg";
export { ForwardRef as ReactComponent };